import { createContext, useContext } from 'react';

// Holds { id, business_name, owner_name, city } when the app is accessed
// from a seller's custom domain, or null on the main marketplace domain.
export const SellerDomainContext = createContext(null);

export function useSellerDomain() {
  return useContext(SellerDomainContext);
}
